

import RecordForm from '../components/RecordForm';
import CategoryRecordsView from '../components/CategoryRecordsView';

import React, { useState } from 'react';

const BillsExpensesPage = () => {
  const [recordsReloadKey, setRecordsReloadKey] = useState(0);
  const handleRecordAdded = () => {console.log(recordsReloadKey); 
    setRecordsReloadKey(prev => {
  const next = prev + 1;
  console.log('new value', next);
  return next;
});
  };
  return (
    <div>
      <h2>Bills / Expenses</h2>
      <RecordForm type="expense" showAllPurposes={false} onRecordAdded={handleRecordAdded} />
      <CategoryRecordsView category="EXPENSE" tabLabels={{pending: 'Pending', approved: 'Approved', rejected: 'Rejected'}} recordsReloadKey={recordsReloadKey} />
    </div>
  );
};
export default BillsExpensesPage;
